import { render, staticRenderFns } from "./AssumptionsImpactsEffectiveDate.vue?vue&type=template&id=6801e78d&"
import script from "./AssumptionsImpactsEffectiveDate.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsEffectiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports